// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomCursor_container__vS3T_","cursor":"CustomCursor_cursor__oZGGZ"};